import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { get } from "../../../server/actions";
import logo from '../../../assets/img/mealManageLogo.PNG'
import PropTypes from 'prop-types'
let loginUserInfo = {}
class CatererHeader extends Component {
    componentWillMount = () => {
        try {
            loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserDetails') || {});
            this.setState({ schoolName: loginUserInfo.name || '' });
        } catch (ex) {
        }

    }
    onLogoutClick = () => {
        console.log('this', this.context.router.history)
        let request = new Promise((resolve) => (get('/logout?access_token=').then(response => {
            console.log('resp', response);
            if (!response.ok || response.ok) {
                resolve(sessionStorage.clear());
            }
        })));
        Promise.resolve(request).then(() => {
            console.log('this', this.context.router.history);
            //this.context.router.history.push({pathname: '/login'});
            window.location.replace('/login');// redirect to login
        });
    }
    constructor() {
        super()
        this.state = {
            schoolName: '',
            schoolLogo: ''
        }
    }
    render() {
        return (
            <header id="pageTop" className="header-wrapper">
                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                    <div className="container">
                        <div className="navbar-header" style={{ position: 'relative' }}>
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                data-target="#navbar">
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <Link className="navbar-brand school-admin-brand" id="brand" to="/caterer"><img
                                className="admin-logo" src={this.state.schoolLogo ? this.state.schoolLogo : logo}
                                alt="" />
                                <div className="school-name">
                                    <span>{this.state.schoolName.toUpperCase()}</span>
                                </div>
                            </Link>
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{ height: 'auto' }}>
                                <li className=" dropdown color-5 active">
                                    <Link to="/caterer" role="button" aria-haspopup="true" aria-expanded="false"><i
                                        className="fa fa-home bg-color-1" aria-hidden="true" /> <span>Home</span></Link>
                                </li>

                                <li className=" dropdown megaDropMenu color-2 ">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        data-hover="dropdown" aria-haspopup="true" data-delay="300"
                                        data-close-others="true" aria-expanded="false">
                                        <i className="fa fa-server bg-color-2" aria-hidden="true"></i>
                                        <span>Manage</span>
                                    </a>
                                    <ul className="row dropdown-menu">
                                       {/*  <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>Schools</li>
                                            </ul>
                                        </li> */}
                                        {/* <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>Meals</li>
                                                <li className=''><Link to="/caterer/menuMasterList" > Menu Items</Link></li>
                                                <li className=""><Link to="/caterer/createMenu">Create Menu</Link></li>
                                            </ul>
                                        </li> */}
                                        <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>Orders</li>
                                                <li className=''><Link to="/caterer/orders">Orders Report</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className="dropdown singleDrop color-6">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-sliders bg-color-4" aria-hidden="true" /> <span>Settings</span></a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        {/*  <li><Link to="/schoolAdmin/manageUsers"> <i className="fa fa-user"/> Manage Users
                                        </Link></li> */}
                                    </ul>
                                </li>
                                <li className="dropdown singleDrop color-6">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-user bg-color-6" aria-hidden="true" /> <span>Account</span></a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        {/* <li><Link to="/schoolAdmin/account"> <i className="fa fa-user"/> Profile Details
                                        </Link></li>*/}
                                        <li onClick={this.onLogoutClick.bind(this)}><Link to="/login"> <i
                                            className="fa fa-power-off" /> Logout</Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
        )
    }
}
CatererHeader.contextTypes = {
    router: PropTypes.object.isRequired
}
export default CatererHeader;


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/CatererHeader.jsx